import { Box, Group, Image, Menu, Stack, Text, BoxProps } from '@mantine/core';
import { IconDotsVertical, IconLogout, IconSettings } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { logoutHandler } from '../../utils/MsalAuthHandler';
import { useMsal } from '@azure/msal-react';
import { coreApi } from '../../utils/CoreAPI';
import Logo from "../../assets/img/brand.png"

function NavbarAccountSection({ ...props }: BoxProps) {
    const { instance } = useMsal();
    const [photoUrl, setPhotoUrl] = useState<string>("");

    useEffect(() => {
        const getProfilePhoto = async () => {
            const response = await coreApi.getBlob("https://graph.microsoft.com/v1.0/me/photo/$value");

            if (response.data) {
                const imageUrl = URL.createObjectURL(response.data);
                setPhotoUrl(imageUrl);
            }
        };

        // getProfilePhoto();
    }, []);

    return (
        <Box style={{ borderTop: "1px solid var(--border-color)" }} pt={8} mt={"auto"} {...props}>
            <Menu shadow="md" position="right" width={220} withArrow>
                <Menu.Target>
                    <Group className="unify-account-section">
                        <Image src={photoUrl} fallbackSrc={Logo} h="32px" w="auto" radius="100%" />
                        <Stack gap="0">
                            <Text truncate="end" size="md">{instance.getActiveAccount()?.name}</Text>
                            <Text truncate="end" size="xs" c="var(--text-dimmed)">{instance.getActiveAccount()?.username}</Text>
                        </Stack>
                        <IconDotsVertical size={"1.125rem"} color="var(--text-dimmed)" />
                    </Group>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Label>Account</Menu.Label>
                    <Menu.Item leftSection={<IconSettings size={"0.875rem"} />}>
                        Settings
                    </Menu.Item>
                    <Menu.Item leftSection={<IconLogout size={"0.875rem"} />} onClick={logoutHandler}>
                        Sign Out
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Box>
    )
};

export default NavbarAccountSection;